<template>
  <div class="button-card">
    <p
      v-if="cardTitle"
      class="card-title"
    >
      {{ $t(cardTitle) }}
    </p>
    <div
      class="button-card_content"
      :class="{white:white}"
    >
      <p class="text">
        {{ $t(contentText) }}
      </p>
      <div class="btn">
        <slot name="btn" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ButtonCard",
  props: {
    outlineButton: {
      type: Boolean,
      default: false,
    },
    cardTitle: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    contentText: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.button-card {
  .card-title {
    font-size: 1rem;
    font-weight: bold;
    line-height: 1.38;
    letter-spacing: 1px;
    color: var(--gray-900);
  }
  .button-card_content {
    @include auto_margin_top(10px);
    padding: 20px;
    border-radius: 10px;
    border: solid 1px #d8d8d8;
    &.white {
      border: none;
      background-color: var(--white);
    }
    .text {
      @include auto_margin_top(10px);
      font-size: 1rem;
      line-height: 1.38;
      letter-spacing: 1px;
      color: var(--gray-900);
    }
    .btn {
      @include auto_margin_top(20px);
    }
  }
}
</style>